/**
 * Renders an empty cell with a placeholder.
 * @returns JSX.Element
 */
export const EmptyCellRenderer = () => {
  return <span style={{ fontStyle: "italic", color: "#888" }}>&empty;</span>;
};
